// extracted by css-extract-rspack-plugin
export default {"SnippetButton":"SnippetRow-module__SnippetButton___kzH_g","SnippetContent":"SnippetRow-module__SnippetContent___DnhNM"};